import { LevelRow } from '../types/survey';

type Props = {
  rows: LevelRow[];
  onChangeRows: (rows: LevelRow[]) => void;
};

export default function OCRValidationPanel({ rows, onChangeRows }: Props) {
  const update = (id: string, key: keyof LevelRow, value: string) => {
    onChangeRows(rows.map(r => r.id === id ? { ...r, [key]: value } : r));
  };

  const remove = (id: string) => {
    onChangeRows(rows.filter(r => r.id !== id));
  };

  return (
    <div style={{ marginTop: '15px' }}>
      <h3>OCR Validation</h3>

      <div style={{ overflowX: 'auto' }}>
        <table border={1} cellPadding={5} style={{ width: '100%' }}>
          <thead>
            <tr>
              <th>Chainage</th>
              <th>Offset</th>
              <th>Side</th>
              <th>BS</th>
              <th>IS</th>
              <th>FS</th>
              <th>TBM</th>
              <th>Remarks</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {rows.map(row => (
              <tr key={row.id}>
                <td><input value={row.chainage} onChange={e => update(row.id, 'chainage', e.target.value)} /></td>
                <td><input value={row.offset} onChange={e => update(row.id, 'offset', e.target.value)} /></td>
                <td>
                  <select value={row.side} onChange={e => update(row.id, 'side', e.target.value)}>
                    <option value="Center">Center</option>
                    <option value="LHS">LHS</option>
                    <option value="RHS">RHS</option>
                  </select>
                </td>
                <td><input value={row.bs} onChange={e => update(row.id, 'bs', e.target.value)} /></td>
                <td><input value={row.is} onChange={e => update(row.id, 'is', e.target.value)} /></td>
                <td><input value={row.fs} onChange={e => update(row.id, 'fs', e.target.value)} /></td>
                <td><input value={row.tbmValue} onChange={e => update(row.id, 'tbmValue', e.target.value)} /></td>
                <td>
                  <select value={row.remarks} onChange={e => update(row.id, 'remarks', e.target.value)}>
                    <option value="">Blank</option>
                    <option value="LE">LE</option>
                    <option value="RE">RE</option>
                    <option value="CP">CP</option>
                    <option value="TBM">TBM</option>
                  </select>
                </td>
                <td><button type="button" onClick={() => remove(row.id)}>Delete</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
